export default __webpack_public_path__ + "static/media/arrow-right.93d61026.svg";